import {Component, Input, OnInit} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {ApiService} from "../../../../services/api.service";
import {NzModalRef} from "ng-zorro-antd/modal";

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {

  @Input() confirmationMessage: string;
  @Input() actionURL: string;
  @Input() actionMethod: 'Get' | 'Post' | 'Delete' | 'Put';
  @Input() actionData: any;
  @Input() submitButton: string = 'Submit';
  @Input() contentType: string = 'string';
  @Input() completeMode: 'triggerOk' | 'close' = 'triggerOk';

  error$: BehaviorSubject<string>;
  isLoading$: BehaviorSubject<boolean>;

  constructor(public api: ApiService, private modal: NzModalRef) {
    this.isLoading$ = new BehaviorSubject<boolean>(false);
    this.error$ = new BehaviorSubject<string>('');
  }

  ngOnInit(): void {
  }

  destroyModal(): void {
    this.modal.destroy();
  }

  confirm(){

    this.isLoading$.next(true);
    if(this.actionMethod === 'Get'){
      this.api.apiGet(this.actionURL).then((res)=>{
        if(this.completeMode === 'triggerOk'){
        this.modal.triggerOk();
        }else{
          this.modal.destroy(this.actionData);
        }
        this.isLoading$.next(false);
      }).catch((err)=>{
        this.error$.next(err.error.Message);
      })
    }

    if(this.actionMethod === 'Post'){
      this.api.apiPost(this.actionURL, this.actionData).then((res)=>{
        if(this.completeMode === 'triggerOk'){
        this.modal.triggerOk();
        }else{
          this.modal.destroy(this.actionData);
        }
        this.isLoading$.next(false);
      }).catch((err)=>{
        this.error$.next(err.error.Message);
      })
    }

    if(this.actionMethod === 'Put'){
      this.api.apiPut(this.actionURL, this.actionData).then((res)=>{
        if(this.completeMode === 'triggerOk'){
        this.modal.triggerOk();
        }else{
          this.modal.destroy(this.actionData);
        }
        this.isLoading$.next(false);
      }).catch((err)=>{
        this.error$.next(err.error.Message);
      })
    }

    if(this.actionMethod === 'Delete'){
      this.api.apiDelete(this.actionURL).then((res)=>{
        if(this.completeMode === 'triggerOk'){
        this.modal.triggerOk();
        }else{
          this.modal.destroy(this.actionData);
        }
        this.isLoading$.next(false);
      }).catch((err)=>{
        this.error$.next(err.error.Message);
      })
    }

  }

}
